import { Component, OnInit } from '@angular/core';
import { CustomFieldsService, SaveType } from '@onviobr/bm-core-custom-fields';
import { BentoSideNavItem } from '@bento/bento-ng';
import { TranslateService } from '@ngx-translate/core';
import { CustomFieldsSaveService } from './custom-fields.service';
import { has as hasIac } from '@onviobr/services/access';
import { has as hasFrp } from '@onviobr/services/permission';

type navType = 'sideNav' | 'bentoNav';

@Component({
	selector: 'app-custom-fields',
	templateUrl: './custom-fields.component.html',
	styleUrls: ['./custom-fields.component.css'],
})
export class ClientCustomFieldsComponent implements OnInit {
	public filters = [];
	public clientNavType: navType = 'bentoNav';
	public items: BentoSideNavItem[] = [];
	private navigationService = CustomFieldsSaveService;
	hasIac = hasIac;
	hasFrp = hasFrp;

	constructor(private cfService: CustomFieldsService, private translate: TranslateService) {
		this.navigationService.component = this;
	}

	async ngOnInit() {
		const allClientsTranslation = await this.translate.get('onvio.core.customFields.allClients').toPromise();
		const allIndividualsTranslation = await this.translate.get('onvio.core.customFields.allIndividuals').toPromise();
		const allBusinessesTranslation = await this.translate.get('onvio.core.customFields.allBusinesses').toPromise();
		const clientsTranslation = await this.translate.get('Onvio.Core.Customfields.Tab.Client').toPromise();

		await this.setSidenavPermissions();

		this.items.push({
			label: clientsTranslation,
			selected: true
		});
		this.filters = [
			{ key: 'All Clients', value: allClientsTranslation },
			{ key: 'All Individuals', value: allIndividualsTranslation },
			{ key: 'All Businesses', value: allBusinessesTranslation }];

		await this.loadData();
	}

	async setSidenavPermissions() {
		const [showSideNav, revertSideNav] = await Promise.all([
			this.hasFrp('Internal.SidenavTree').catch(() => false),
			this.hasIac('OnvioCenterRevertSideNavEnhancements').catch(() => false)]);

		if (showSideNav && !revertSideNav) {
			this.clientNavType = 'sideNav';
		} else {
			this.clientNavType = 'bentoNav';
		}
	}

	async loadData() {
		await this.cfService.load();
	}

	async saveButtonClicked() {
		await this.cfService.save(SaveType.Manual);
	}

	async cancelButtonClicked() {
		await this.cfService.load();
	}

	async savedOnNavigationAway(): Promise<void> {
		await this.cfService.save(SaveType.NavigationAway);
	}
}
